import preloader from "monoame-preloader";

let sights = [{
        name: "beimen",
        name_zh: "北門",
        name_en: "Taipei City Wall-North Gate",
        position: {
            bottom: 65,
            left: 55
        },
        width: 15,
        maxWidth: 100,
        media: {
            pano: "beimen_pano-min.jpg",
            vr: null,
            video: null,
            panoDefault: {
                defaultLong: 2 * Math.PI * (-8 / 360),
                defaultLat: (Math.PI / 2) * (30 / 180),
                defaultZoomLvl: 10,
                sphereCorrection: {
                    roll: 2 * Math.PI * (4 / 360)
                }
            }
        }
    },
    {
        name: "honglou",
        name_zh: "西門",
        name_en: "Ximen",
        position: {
            bottom: 50,
            left: 25
        },
        width: 25,
        maxWidth: 150,
        panX: 3,
        media: {
            pano: "honglou_pano-min.jpg",
            vr: "https://3d.taipei/culture/indoor.html?m=mQy237SEGdu&t=%E8%A5%BF%E9%96%80%E7%B4%85%E6%A8%93",
            video: null,
            panoDefault: {
                defaultLong: 2 * Math.PI * (15 / 360),
                defaultLat: (Math.PI / 2) * (25 / 180),
                defaultZoomLvl: 10,
                sphereCorrection: {
                    roll: 2 * Math.PI * (1 / 360)
                }
            }
        }
    },
    {
        name: "songyan",
        name_zh: "松山文創園區",
        name_en: "Songshan Cultural and Creative Park",
        position: {
            bottom: 63,
            left: 10
        },
        width: 25,
        maxWidth: 150,
        panX: 2,
        media: {
            pano: null,
            vr: null,
            video: "https://www.youtube.com/watch?v=PAcQ8Ned_xc",
            panoDefault: null
        }
    },
    {
        name: "dadaocheng",
        name_zh: "大稻埕",
        name_en: "Dadaocheng",
        position: {
            bottom: 25,
            left: 50
        },
        width: 25,
        maxWidth: 150,
        media: {
            pano: "dadaocheng_pano-min.jpg",
            vr: "https://3d.taipei/culture/indoor.html?m=uF21SMQfbWs&t=%E6%96%B0%E8%8A%B3%E6%98%A5%E8%8C%B6%E8%A1%8C",
            video: null,
            panoDefault: {
                defaultLong: 2 * Math.PI * (7 / 360),
                defaultLat: (Math.PI / 2) * (35 / 180),
                defaultZoomLvl: 1,
                sphereCorrection: {
                    roll: 2 * Math.PI * (0 / 360)
                }
            }
        }
    },
    {
        name: "longshan",
        name_zh: "龍山寺",
        name_en: "Lungshan Temple",
        position: {
            bottom: 33,
            left: 30
        },
        width: 27,
        maxWidth: 150,
        media: {
            pano: "longshan_pano-min.jpg",
            vr: "https://3d.taipei/culture/indoor.html?m=1rWZfF1uStR&t=%E5%89%9D%E7%9A%AE%E5%AF%AE%E6%AD%B7%E5%8F%B2%E8%A1%97%E5%8D%80",
            video: null,
            panoDefault: {
                defaultLong: 2 * Math.PI * (10 / 360),
                defaultLat: (Math.PI / 2) * (15 / 180),
                defaultZoomLvl: 1
            }
        }
    },
    {
        name: "moma",
        name_zh: "中山",
        name_en: "Zhongshan",
        position: {
            bottom: 45,
            left: 50
        },
        width: 20,
        maxWidth: 150,
        media: {
            pano: "moma_pano-min.jpg",
            vr: "https://3d.taipei/culture/indoor.html?m=3SitzibMYo2&t=%E5%85%89%E9%BB%9E%E5%8F%B0%E5%8C%97(%E5%8F%B0%E5%8C%97%E4%B9%8B%E5%AE%B6)",
            video: null,
            panoDefault: {
                defaultLong: 2 * Math.PI * (14 / 360),
                defaultLat: (Math.PI / 2) * (22 / 180),
                defaultZoomLvl: 1,
                sphereCorrection: {
                    roll: 2 * Math.PI * (0 / 360)
                }
            }
        }
    },
    {
        name: "101",
        name_zh: "台北101",
        name_en: "Taipei 101",
        position: {
            bottom: 35,
            left: 70
        },
        width: 13,
        maxWidth: 70,
        media: {
            pano: "101_pano-min.jpg",
            vr: null,
            video: null,
            panoDefault: {
                defaultLong: 2 * Math.PI * (-10 / 360),
                defaultLat: (Math.PI / 2) * (55 / 180),
                defaultZoomLvl: 30
            }
        }
    }
]
let exploreMapImg = require('@/assets/images/explore_bkg_all.png')
let magnifier = require('@/assets/images/explore_magnifier.png')

let imgUrls = [exploreMapImg, magnifier]

for (let i = 0; i < sights.length; i++){
    let sight = sights[i]
    imgUrls.push(require(`@/assets/images/explore_${sight.name}.png`))
    // if(sight.media.pano){
    //     imgUrls.push(require(`@/assets/images/${sight.media.pano}`))
    // }
}

// console.log(imgUrls)

// Preload
preloader
    .load(imgUrls)
    .then(() => {
        console.log("image all preloaded!");
    })
    .catch(() => {
        console.log("image preload fail.");
    });
